module.exports = __webpack_public_path__ + "static/lastPartOfArrangement-626f571503a71e2a74e10f33d7a9feea.mp3";